import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileContract, faEnvelope, faPhone, faMapMarkerAlt, faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";

const services = [
  "Surveillance cameras and video monitoring systems.",
  "Access control systems and components.",
  "Burglar alarms and intrusion detection systems.",
  "Intercom systems and communications equipment.",
  "Battery chargers and testing equipment.",
  "Installation, configuration, and support services.",
  "Geographic Information Systems (GIS) and digital land surveying products.",
  "Professional security system design and consulting.",
];

const brands = ["Hanwha Techwin", "Verkada", "Panduit", "General Cable", "EPCOM"];

const professionalServices = [
  "Network Engineer",
  "Project Manager",
  "Installation Technician",
];

const Contract6167 = () => {
  return (
    <div id="GovernmentContracts">
      {/* Hero */}
      <div id="header" style={{ minHeight: "44vh" }}>
        <div className="hero-inner">
          <Link to="/government-contracts" className="contract-back-link">
            &larr; All Contracts
          </Link>
          <div className="hero-eyebrow">Texas DIR Contract</div>
          <h1 className="hero-headline">DIR-CPO-6167</h1>
          <p className="hero-sub">
            Law Enforcement &amp; Security Systems — Surveillance, Access Control, and Physical Security Infrastructure
          </p>
        </div>
      </div>

      <section id="gov-contracts-section">
        <div className="container">
          <div className="contract-card">

            {/* Header */}
            <div className="contract-header">
              <div className="contract-logo">
                <img src="/img/dir_logo.png" alt="DIR Logo" />
              </div>
              <div className="contract-title">
                <h2>
                  <FontAwesomeIcon icon={faFileContract} className="contract-icon" />
                  DIR-CPO-6167
                </h2>
                <p className="contract-subtitle">Law Enforcement &amp; Security Systems</p>
              </div>
              <div className="contract-status-badge">Active</div>
            </div>

            {/* Description */}
            <div className="contract-description">
              <p>
                Enteranet, LLC has been awarded a contract by the <strong>Texas Department of Information Resources (DIR)</strong> under
                Contract Number DIR-CPO-6167 for Law Enforcement and Security Systems products and related services.
              </p>
              <p>
                This contract enables eligible Texas state agencies, local governments, public education institutions, and other
                authorized entities to procure security infrastructure, surveillance systems, and access control solutions
                at negotiated, cost-effective rates — without a separate competitive bid process.
              </p>
              <p>
                As an authorized partner of <strong>Hanwha Techwin, Verkada, and Panduit</strong>, Enteranet delivers
                enterprise-grade physical security systems, IP surveillance, and access control infrastructure tailored
                for public sector, law enforcement, and government facilities.
              </p>
            </div>

            {/* Services */}
            <div className="contract-services">
              <h3>Contract Services</h3>
              <div className="services-grid">
                {services.map((s, i) => (
                  <div key={i} className="service-item">
                    <span className="service-checkmark">&#10003;</span>
                    <span>{s}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Brands & Professional Services */}
            <div className="contract-services" style={{ borderTop: "1px solid var(--border)" }}>
              <div className="contract-two-col">
                <div>
                  <h3>Brands Offered</h3>
                  <div className="services-grid" style={{ gridTemplateColumns: "1fr" }}>
                    {brands.map((b, i) => (
                      <div key={i} className="service-item">
                        <span className="service-checkmark">&#10003;</span>
                        <span>{b}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div>
                  <h3>Professional Services</h3>
                  <div className="services-grid" style={{ gridTemplateColumns: "1fr" }}>
                    {professionalServices.map((p, i) => (
                      <div key={i} className="service-item">
                        <span className="service-checkmark">&#10003;</span>
                        <span>{p}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* How to Order + Resources */}
            <div className="contract-footer">
              <div className="row">
                <div className="col-md-6">
                  <div className="info-box">
                    <h4>How to Order</h4>
                    <div className="contact-info">
                      <p className="contact-name"><strong>Robert Bernal</strong></p>
                      <p>
                        <FontAwesomeIcon icon={faEnvelope} className="info-icon" />
                        <a href="mailto:rbernal@enteranet.com">rbernal@enteranet.com</a>
                      </p>
                      <p>
                        <FontAwesomeIcon icon={faPhone} className="info-icon" />
                        <a href="tel:+14697900083">(469) 790-0083</a> |
                        <a href="tel:+19035303930"> (903) 530-3930</a>
                      </p>
                      <p>
                        <FontAwesomeIcon icon={faMapMarkerAlt} className="info-icon" />
                        715 Private Road 5939 Ste 4, Lavon, TX 75166
                      </p>
                      <p className="important-note">
                        <strong>Important:</strong> Reference Contract Number DIR-CPO-6167 on your purchase order
                      </p>
                    </div>
                  </div>

                  <div className="info-box">
                    <h4>Warranty</h4>
                    <p>Warranty coverage aligns with OEM manufacturer terms. Contact us for specifics during your quote or order.</p>
                  </div>

                  <div className="info-box">
                    <h4>Return Policy</h4>
                    <p>All sales are final. Returns do not apply to this contract.</p>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="info-box">
                    <h4>Resources &amp; Links</h4>
                    <div className="resource-links">
                      <a href="https://dir.texas.gov/contracts/dir-cpo-6167" target="_blank" rel="noopener noreferrer" className="resource-link">
                        <FontAwesomeIcon icon={faExternalLinkAlt} />
                        View DIR Contract Page — DIR-CPO-6167
                      </a>
                      <a href="/Exhibit E Pricing Sheet.xlsx" target="_blank" rel="noopener noreferrer" className="resource-link">
                        <FontAwesomeIcon icon={faExternalLinkAlt} />
                        Download Contract Pricing
                      </a>
                      <a href="https://dir.texas.gov/cooperative-contracts" target="_blank" rel="noopener noreferrer" className="resource-link">
                        <FontAwesomeIcon icon={faExternalLinkAlt} />
                        Learn About DIR Cooperative Contracts
                      </a>
                      <a href="/Exhibit I Policy Driven Adoption for Accessibility PDAA.xlsx" target="_blank" rel="noopener noreferrer" className="resource-link">
                        <FontAwesomeIcon icon={faExternalLinkAlt} />
                        Accessibility — Approved PDAA Form
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Contract6167;
